import { Container } from '@mui/material';
import { EditChallenge } from 'components/templates';
import React from 'react';

export const EditChallengeView = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <EditChallenge />
    </Container>
  );
};
